import moment from "moment";

import { CampaignBriefProps } from "../../../features/brief-list/types/props/campaign-brief.props";

import { TCampaignBriefResults } from "./campaign-briefs.interface";

export const mapCampaignBriefResultsToCampaignBriefProps = (
  origData?: TCampaignBriefResults[]
): CampaignBriefProps[] => {
  if (!origData) {
    return [];
  }

  return origData.map((item) => ({
    ...item,
    startAt: item.startAt ? moment(item.startAt).format("MMM DD") : "",
    endAt: item.endAt ? moment(item.endAt).format("MMM DD") : "",
    createdDate: moment(item.createdAt).format("YYYY-MM-DD"),
    ownerName: `${item.briefOwner.firstName} ${item.briefOwner.lastName}`,
  }));
};
